var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('data-table',{attrs:{"edit-item":_vm.editItem,"now":true}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }